import { render, staticRenderFns } from "./CompanyCompanyList.vue?vue&type=template&id=4d8755bf&scoped=true&"
import script from "./CompanyCompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCompanyList.vue?vue&type=style&index=0&id=4d8755bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8755bf",
  null
  
)

export default component.exports